angular.module('impactx.sso').controller('SamlSsoSettingsCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    'ToolbarService',
    SamlSsoSettingsCtrl]);

function SamlSsoSettingsCtrl($scope, dataGen, ToastService, ToolbarService) {
    var self = this;
    dataGen.getData($scope, {}, "/login/saml2/idpmetadata").then(function () {
        defineButtons();
    });

    self.refresh = function (idpIssuer) {
        dataGen.getData($scope, {idpIssuer: idpIssuer.value}, "/login/saml2/refreshidpmetadata").then(function () {
            ToastService.openStandardToast($scope.trns.refreshSuccess);
        })
    };
    self.read = function (idpIssuer) {
        dataGen.getData($scope, {idpIssuer: idpIssuer.value}, "/login/saml2/readidpmetadata").then(function () {
            ToastService.openStandardToast($scope.trns.readSuccess);
        })
    };

    function defineButtons() {
        ToolbarService.setButtons([]);
    }

    this.canRead = function(setting) {
        return !hasConfigUrl() && hasSamlAuthenticator() && setting.isSet && setting.xmlDiffersFromActiveData;
    }

    this.canRefresh = function(setting) {
        return hasConfigUrl(setting) && hasSamlAuthenticator();
    }

    function hasConfigUrl(setting) {
        return setting && setting.configUrlIsSet;
    }

    function hasSamlAuthenticator() {
        return !$scope.data.noSamlAuthenticator;
    }
}